/**
 * Rupiah helpers used by the agreement value inputs and the Summary page.
 */

/** 1500000 -> "1.500.000" */
export const formatThousands = (value: number | null | undefined): string => {
  if (value === null || value === undefined || isNaN(Number(value))) return '';
  return Math.round(Number(value)).toLocaleString('id-ID');
};

/** 1500000 -> "Rp 1.500.000" */
export const formatRupiah = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '-';
  return `Rp ${formatThousands(value)}`;
};

/** Compact form like the reference design: 301254000 -> "Rp 301 jt", 1.5e9 -> "Rp 1,5 M" */
export const formatRupiahCompact = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '-';
  const v = Number(value);
  const fmt = (n: number) => n.toLocaleString('id-ID', { maximumFractionDigits: n < 10 ? 1 : 0 });
  if (Math.abs(v) >= 1e12) return `Rp ${fmt(v / 1e12)} T`;
  if (Math.abs(v) >= 1e9) return `Rp ${fmt(v / 1e9)} M`;
  if (Math.abs(v) >= 1e6) return `Rp ${fmt(v / 1e6)} jt`;
  if (Math.abs(v) >= 1e3) return `Rp ${fmt(v / 1e3)} rb`;
  return `Rp ${fmt(v)}`;
};

/** Keep digits only: "Rp 1.500.000" -> 1500000, "" -> null */
export const parseDigits = (text: string | number | null | undefined): number | null => {
  if (text === null || text === undefined) return null;
  const digits = String(text).replace(/[^\d]/g, '');
  return digits ? Number(digits) : null;
};
